var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "launch",
    clipPath: "url(#clip0_634_3094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3621 19.5H5.36206V5.5H12.3621V3.5H5.36206C4.25206 3.5 3.36206 4.4 3.36206 5.5V19.5C3.36206 20.6 4.25206 21.5 5.36206 21.5H19.3621C20.4621 21.5 21.3621 20.6 21.3621 19.5V12.5H19.3621V19.5ZM14.3621 3.5V5.5H17.9521L8.12206 15.33L9.53206 16.74L19.3621 6.91V10.5H21.3621V3.5H14.3621Z",
    fill: "#145758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_3094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.362061 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterNewWindow);
export default __webpack_public_path__ + "static/media/footer-new-window.3bf163589f793472fcb0d46d854e665d.svg";
export { ForwardRef as ReactComponent };